export const HEALTH_CHECK_QUERY_KEY = ["check"];
